import { useState } from 'react';

import { Grid, Breadcrumbs } from '@material-ui/core';

import { ButtonGeneric } from '../atoms/Buttons';

export const GenericBreadcrumb = ({ breads = [], DefaultComponent }) => {
    const initBread = breads.map((x, index) => ({ index, init: x?.init })).find(x => x.init);
    const [activeBreadcrumb, setActiveBreadcrumb] = useState(initBread ? initBread.index : -1);

    const Component = activeBreadcrumb === -1 && DefaultComponent ? DefaultComponent : breads.filter(({ filter }) => filter).find((_, index) => index === activeBreadcrumb)?.Component;

    return (
        <Grid
            container
            spacing={1}
            justify="center"
            alignItems="center"
        >
            <Grid item xs={12}>
                <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
                    {/* <Button
                       
                        onClick={(e) => {
                            setActiveBreadcrumb(MENU_HCE.LISTADO_PACIENTES);
                        }}
                    >
                        <PersonAdd  />
                        Listado de Pacientes
                    </Button> */}
                    {breads.filter(({ filter }) => filter).map(({ Icon, text, onClick = () => { }, disabled = false }, index) => (
                        <ButtonGeneric
                            key={index}
                            variant="text"
                            disabled={disabled}
                            onClick={() => {
                                onClick()
                                setActiveBreadcrumb(index)
                            }}
                            startIcon={Icon}
                            text={text}
                            color={
                                activeBreadcrumb === index
                                    ? "default"
                                    : "inherit"
                            }
                        />
                    ))}
                </Breadcrumbs>
            </Grid>
            {Component && (
                <Grid item xs={12} style={{ marginTop: "1em" }}>
                    <Grid container spacing={1} justify='center'>
                        {Component}
                    </Grid>
                </Grid>
            )}
        </Grid>
    )
}